import baseTheme from '@insync-students-themes/baseTheme';

const getBaseTheme = (colors) => {
  const colorsNeutral = colors.neutral;
  const colorsPrimary = colors.primary;
  return {
    ...baseTheme,
    colors: {
      ...baseTheme.colors,
      neutral: {
        ...baseTheme.colors.neutral,
        ...colorsNeutral,
      },
      primary: {
        ...baseTheme.colors.primary,
        ...colorsPrimary,
      },
    },
  };
};

export const switchTheme = (selectedCurriculumId) => {
  switch (selectedCurriculumId) {
    default:
    case 'EM':
    case 'EMTX':
      return getBaseTheme({
        neutral: {
          base: '#F7F8F9',
          'dark-60': '#727981',
          'dark-80': '#1F2226',
        },
        primary: {
          base: '#7EBB52',
          'dark-80': '#7EBB52',
          'light-20': '#C4E6AC',
          'title-font': '#1F2226',
        },
      });
    case 'GEO':
      return getBaseTheme({
        neutral: {
          base: '#F7F8F9',
           'dark-60': '#727981',
           'dark-80': '#1F2226',
          },
        primary: {
          base: '#1ca6df',
            'dark-80': '#1CA6DF',
            'light-30': '#99D8F2',
            'title-font': '#1F2226',
          },
      });
    case 'PHD':
    case 'PHDTX':
    case 'PHDPILOT':
      return getBaseTheme({
        neutral: {
          'dark-60': '#727981',
          'dark-80': '#1F2226',
        },
        primary: {
          base: '#835AA2',
          'light-30': '#C0A0D9',
          'title-font': '#FFFFFF',
        },
      });
    case 'WW':
      return getBaseTheme({
        neutral: {
          'dark-60': '#727981',
          'dark-80': '#1F2226',
        },
        primary: {
          base: '#7CC7F1',
          'light-20': '#B3DDF4',
          'title-font': '#1F2226',
        },
      });
  }
};
